const MESSAGE_TYPE = "application/x-magic-frame-json";
const INNER_EVENT_KIND = "magic-frame:inner";
const WIZARD_EVENT_KIND = "magic-frame:wizard";
const HANDSHAKE_MAX_ATTEMPTS = 5;
const HANDSHAKE_TIMEOUT = 500;
const INNER_EXECUTE_EVENT = "inner:execute";
const HANDSHAKE_START_EVENT = "handshake:start";
const HANDSHAKE_REPLY_EVENT = "handshake:reply";
const INNER_ROOT_SET_HEIGHT_EVENT = "inner:init-root-height";
const ERROR_INITIALIZE_FAILED = "initialization:failed";
const ERROR_INITIALIZE_HANDSHAKE_FAILED = "initialization:handshake-failed";
const ERROR_INITIALIZE_HANDSHAKE_TIMEOUT = "initialization:handshake-timeout";
const ERROR_EMIT_FAILED = "emit:failed";
var Status = /* @__PURE__ */ ((Status2) => {
  Status2["Idle"] = "idle";
  Status2["Loading"] = "loading";
  Status2["Ready"] = "ready";
  Status2["Error"] = "error";
  Status2["Unloaded"] = "unloaded";
  return Status2;
})(Status || {});
const UNINITIALIZED_STATUSES = /* @__PURE__ */ new Set(["idle" /* Idle */, "unloaded" /* Unloaded */, "loading" /* Loading */]);

export { ERROR_EMIT_FAILED, ERROR_INITIALIZE_FAILED, ERROR_INITIALIZE_HANDSHAKE_FAILED, ERROR_INITIALIZE_HANDSHAKE_TIMEOUT, HANDSHAKE_MAX_ATTEMPTS, HANDSHAKE_REPLY_EVENT, HANDSHAKE_START_EVENT, HANDSHAKE_TIMEOUT, INNER_EVENT_KIND, INNER_EXECUTE_EVENT, INNER_ROOT_SET_HEIGHT_EVENT, MESSAGE_TYPE, Status, UNINITIALIZED_STATUSES, WIZARD_EVENT_KIND };
